import React from 'react';
import { motion } from 'framer-motion';
import { Trash2, Warehouse, Sofa, Zap } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
export function ServicesGrid() {
  const services = [{
    icon: Trash2,
    title: 'Residential & Commercial Junk Removal',
    description: 'Homes, offices, rentals, job sites. One item or a full truckload.'
  }, {
    icon: Warehouse,
    title: 'Garage Cleaning & Organization',
    description: 'We clear it out, sweep it clean, and help you reclaim the space.'
  }, {
    icon: Sofa,
    title: 'Furniture & Appliance Pickup',
    description: 'Couches, beds, fridges, washers. The heavy stuff we actually enjoy hauling.'
  }, {
    icon: Zap,
    title: 'Same-Day & Next-Day Service',
    description: "Need it gone today? Text a photo. We'll be there."
  }];
  return <section id="services" className="relative py-20 md:py-28 bg-navy" data-id="element-202">
      <div className="container mx-auto px-4" data-id="element-203">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12 md:mb-16" data-id="element-204">
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl text-white tracking-wider mb-4" data-id="element-205">
            WHAT WE <span className="text-lime" data-id="element-206">HAUL</span>
          </h2>
          <div className="w-32 h-1 bg-lime mx-auto mb-6" data-id="element-207" />
          <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto" data-id="element-208">
            If it fits in a truck and it needs to go, we've got you. Here's what
            we handle daily.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 gap-6 md:gap-8 mb-12" data-id="element-209">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -8,
          scale: 1.02
        }} className="group" data-id="element-210">
              <Card className="bg-navy/50 border-2 border-lime/40 p-6 md:p-8 h-full transition-all duration-300 group-hover:border-lime group-hover:shadow-[0_0_30px_rgba(163,230,53,0.3)] backdrop-blur-sm" data-id="element-211">
                <div className="space-y-4" data-id="element-212">
                  {/* Icon */}
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-lime/10 border border-lime/30 group-hover:bg-lime/20 transition-colors" data-id="element-213">
                    <service.icon className="w-7 h-7 text-lime" strokeWidth={2} data-id="element-214" />
                  </div>

                  {/* Title */}
                  <h3 className="font-heading text-2xl md:text-3xl text-white tracking-wide" data-id="element-215">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-white/70 leading-relaxed" data-id="element-216">
                    {service.description}
                  </p>
                </div>
              </Card>
            </motion.div>)}
        </div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="text-center" data-id="element-217">
          <Button variant="outline" size="lg" className="border-2 border-lime text-lime hover:bg-lime/10 font-bold text-lg px-8 rounded-full" data-id="element-218">
            SEE ALL SERVICES →
          </Button>
        </motion.div>
      </div>
    </section>;
}